enum UserProfileType {
    ClubrUser,
    PhoneContact,
    Unkown = 99
}

export default UserProfileType;